import(/* webpackMode: "eager", webpackExports: ["AllergensContent"] */ "/var/www/azia_frontv2_green/src/app/allergens/allergens-content.tsx");
